{
  "acceptedFileFormats": "Jsou přijímány pouze soubory .docx, .pdf, .txt.",
  "actionCompetenceGroup": "Skupina kompetencí akce",
  "actionDeadline": "Termín akce",
  "actionDescription": "Popis akce",
  "actionDuration": "Doba trvání akce",
  "actionEarliestStart": "Nejdřívější začátek akce",
  "actionName": "Název akce",
  "actions": "Akce",
  "actionsAndProjects": "Akce a projekty",
  "actionsColon": "Akce: ",
  "actionsPerformerConstraints": "Omezení vykonavatele akcí",
  "add": "Přidat",
  "addAdmin": "Přidat správce",
  "addAdminTitle": "Přidat správce",
  "addAnalyses": "Přidat analýzy",
  "addAnalysis": "Přidat analýzu",
  "addAnalysisGroup": "Přidat skupinu analýz",
  "addChatbot": "Přidat chatbota",
  "addCompetenceGroup": "Přidat skupinu kompetencí",
  "addConstraint": "Přidat omezení",
  "addGreyTask": "Přidat šedý úkol",
  "addInstrument": "Přidat přístroj",
  "addItemPlaceholder": "Přidat {{item}}...",
  "addLocation": "Přidat místo",
  "addMaintenance": "Přidat údržbu",
  "addMember": "Přidat člena",
  "addNewBundle": "Přidat nový balíček",
  "addNewMaintenanceFor": "Přidat novou údržbu pro {{assetName}}",
  "addNewTask": "Přidat nový úkol",
  "addOffsite": "Přidat MIMO PRACOVIŠTĚ",
  "addProjectGroup": "Přidat skupinu projektů",
  "addProjectTemplate": "Přidat šablonu projektu",
  "addRepository": "Přidat úložiště",
  "addRow": "Přidat řádek",
  "addSample": "Přidat vzorek",
  "addSamples": "Přidat vzorky",
  "addTeam": "Přidat tým",
  "additionalInformation": "Další informace",
  "administrators": "Správci",
  "advanced": "Pokročilé",
  "allFilesProcessed": "Všechny nahrané soubory byly zpracovány",
  "allowMembersMoveOthersOperationalTasks": "Povolit členům přesouvat provozní úkoly ostatních",
  "allowedCompetenceGroups": "Povolené skupiny kompetencí",
  "allowedInstruments": "Povolené přístroje",
  "amountOfSamples": "Počet vzorků: {{count}}",
  "analyses": "Analýzy",
  "analysesRelatedTo": "Analýzy související s {{product}}",
  "analysis": "Analýza",
  "analysisAndSampleDone": "Analýza i vzorek jsou dokončeny",
  "analysisDefinition": "definice analýzy",
  "analysisDesignTool": "Nástroj pro návrh analýzy",
  "analysisDone": "Analýza je dokončena",
  "analysisDraft": "NÁVRH analýzy",
  "analysisGroup": "Skupina analýz",
  "analysisGroupName": "Název skupiny analýz",
  "analysisIsFlagged": "Analýza je označena",
  "analysisMustContainTaskDefinition": "Analýza musí obsahovat definici úkolu",
  "analysisName": "Název analýzy",
  "analysisNameMustBeUnique": "Název analýzy musí být jedinečný",
  "analysisNotPlanned": "Tato analýza není naplánována",
  "analysisPlanned": "Analýza je naplánována",
  "analysisTaskBundle": "Balíček úkolů analýzy {{index}}",
  "cdmoTargetedBundle": "Seskupit úkoly podle názvu analýzy",
  "analysisTaskTimePerformerSamples": "Úkol analýzy – čas, vykonavatel, počet vzorků",
  "analysisTasks": "úkoly analýzy",
  "analysisTasksToBundle": "Úkoly analýzy k seskupení",
  "analysisTimePercentage": "Podíl času analýzy z celkového času (A2T)",
  "anywhere": "Kdekoliv",
  "apiToken": "Token API",
  "archiveMember": "Archivovat člena",
  "archived": "archivováno",
  "areYouSureConnection": "Jste si jisti, že chcete toto propojení?",
  "areYouSureConnectionMode": "Jste si jisti, že chcete přejít do režimu 's propojením'? Tímto odstraníte všechna stávající propojení",
  "areYouSureDeleteAdmin": "Jste si jisti, že chcete smazat tohoto správce?",
  "areYouSureDiscardSimulation": "Jste si jisti, že chcete zahodit změny provedené v simulačním režimu?",
  "areYouSurePublishSimulation": "Jste si jisti, že chcete publikovat změny provedené v simulačním režimu?",
  "areYouSureReset": "Jste si jisti, že chcete obnovit výchozí stav? Tím smažete všechny uzly.",
  "areYouSureUnplanAllFutureActions": "Jste si jisti, že chcete odplánovat všechny budoucí akce v tomto projektu?",
  "areYouSureWantToExit": "Jste si jisti, že chcete odejít?",
  "arrival": "Příjezd",
  "assetAddedOrRemoved": "Aktivum bylo přidáno nebo odebráno",
  "assetRequirementsForAsset": "Požadavky na aktivum {{index}}",
  "assets": "Aktiva",
  "atLeast1LowercaseLetter": "alespoň 1 malé písmeno",
  "atLeast1Number": "alespoň 1 číslo",
  "atLeast1UppercaseLetter": "alespoň 1 velké písmeno",
  "atLeast8Characters": "alespoň 8 znaků",
  "automaticImportConversionSheet": "Automatický převodní list importu {{type}}",
  "automaticSheetConfiguration": "Automatická konfigurace listu",
  "availability": "Dostupnost",
  "availableTimeOneWeek": "Dostupný čas za týden: ",
  "avgAnalysisDuration": "Průměrná doba trvání analýzy: ",
  "avgSampleBatchInterval": "Průměrný interval dávky vzorků: ",
  "avgSamplesAllocated": "Průměrný počet přidělených vzorků: ",
  "backlog": "Nevyřízené položky",
  "booked": "Zarezervováno",
  "bookedBy": "Zarezervoval/a",
  "byCompetenceGroup": "Podle skupiny kompetencí",
  "byDeadline": "Podle termínu",
  "byGroup": "Podle skupiny",
  "byText": "Podle textu",
  "canBePerformedAnywhere": "Lze provést kdekoliv",
  "canOnlyBePerformedOnSite": "Lze provést pouze na místě",
  "cancel": "Zrušit",
  "cancelChanges": "Zrušit změny",
  "cannotUnlockStartedTasks": "Nelze odemknout, protože jeden nebo více úkolů je zahájeno/pozastaveno/dokončeno",
  "changeLogs": "Protokoly změn",
  "changesHaveBeenMade": "Byly provedeny změny, načtěte stránku znovu pro nová data",
  "chatbotGreeting": "Dobrý den, jsem váš AI CHATBOT, specializovaný na dokumentaci nápovědy Plannertech a Librarian a na datová úložiště, která jste importovali.\nMůžete se také vždy obrátit na naši lidskou podporu na pt@arnvind.com od 9 do 16 SEČ.\nJak vám mohu pomoci? :-)",
  "chatbotName": "Název chatbota",
  "chatbotPlaceholder": "Napište krátký popis toho, jak by se měl chatbot chovat.",
  "chatbots": "Chatboti",
  "chattingWith": "Chatování s {{name}}",
  "chooseAction": "Vybrat akci",
  "chooseTask": "Vybrat úkol",
  "chooseWhatToAdd": "Vyberte, co chcete přidat",
  "cleanUp": "Vyčistit",
  "clear": "Vymazat",
  "clearConversation": "Vymazat konverzaci",
  "clearDates": "Vymazat data",
  "clearTable": "Vymazat tabulku",
  "clickToSelectOtherFiles": "Kliknutím vyberte jiné soubory",
  "close": "Zavřít",
  "closeMessage": "zavřít zprávu",
  "closePanel": "Zavřít panel",
  "collaborator": "Spolupracovník",
  "collaborators": "Spolupracovníci",
  "domain": "Doména",
  "color": "Barva",
  "columnName": "Název sloupce",
  "companyWideChatbot": "Chatbot pro celou firmu",
  "competenceAndInstrumentConstraints": "Omezení kompetencí a přístrojů",
  "competenceGroup": "Skupina kompetencí",
  "competenceGroupNameExists": "Skupina kompetencí s tímto názvem již existuje",
  "competenceGroups": "Skupiny kompetencí",
  "competenceGroupsColon": "Skupiny kompetencí: ",
  "configuration": "Konfigurace",
  "confirm": "Potvrdit",
  "confirmArchivalOfMember": "Potvrdit archivaci člena: {{initials}}",
  "confirmClearTable": "Opravdu chcete vymazat tabulku?",
  "confirmDeleteAllData": "Potvrzením smažete všechna data {{type}}. Vrácení zpět není možné, ani v simulačním režimu.",
  "confirmDeleteAllUnplannedProjects": "Potvrzením smažete všechny projekty, které nemají žádné akce v plánu",
  "confirmDeleteAllUnplannedSamples": "Potvrzením smažete všechny vzorky, které nemají žádné akce v plánu",
  "confirmDeleteCompetenceGroup": "Potvrdit smazání skupiny kompetencí:",
  "confirmDeleteInstrument": "Opravdu chcete smazat přístroj: {{name}}?",
  "confirmDeleteMaintenance": "Opravdu chcete smazat tuto údržbu?",
  "confirmDeleteSample": "Opravdu chcete smazat tento nenaplánovaný vzorek?",
  "confirmDeleteSampleInfo": "Potvrzením trvale smažete vybraný vzorek",
  "confirmDeletion": "Potvrdit smazání",
  "confirmFailSamples": "Opravdu chcete označit vybrané vzorky jako nevyhovující?",
  "confirmFailSamplesInfo": "Potvrzením označíte vybrané vzorky jako nevyhovující. Duplikát bude umístěn do nabídky nenaplánovaných analýz",
  "confirmFailSamplesQuestion": "Opravdu chcete označit vybrané vzorky jako nevyhovující?",
  "confirmShowPlannedSamplesInfo": "Potvrzením zobrazíte naplánované vzorky",
  "confirmShowPlannedSamplesQuestion": "Opravdu chcete zobrazit naplánované vzorky?",
  "confirmSortByTime": "Opravdu chcete seřadit podle času",
  "confirmUnplanAllFutureActions": "Opravdu chcete odplánovat všechny budoucí akce v tomto projektu?",
  "confirmUnplanAllQuestion": "Opravdu chcete odplánovat všechny {{itemType}}?",
  "confirmUnplanSamplesInfo": "Potvrzením odplánujete vybrané vzorky. Budou umístěny do nabídky nenaplánovaných analýz",
  "confirmUnplanSamplesQuestion": "Opravdu chcete odplánovat vybrané vzorky?",
  "connectionCalculatedInWorkdays": "Propojení vypočítáno v pracovních dnech",
  "connectionCount": "Počet propojení",
  "connections": "Propojení",
  "connectionsAdvancedWarning": "(Používání propojení s termínem nebo nejdřívějším začátkem u akcí je určeno pro pokročilé uživatele)",
  "connectionsPerformersOnly": "Propojení platí pouze pro vykonavatele – nemá vliv na přidělení aktiv",
  "contactArnvindSupport": "Prosím kontaktujte podporu Arnvind na pt@arnvind.com",
  "conversionSheet": "Převodní list",
  "copyToClipboard": "zkopírovat do schránky",
  "country": "Země",
  "create": "Vytvořit",
  "createANewColumn": "Vytvořit nový sloupec",
  "createAction": "Vytvořit akci",
  "createChatbot": "Vytvořit chatbota",
  "createEditChatbots": "Vytvořit/upravit chatboty",
  "createEditRepositories": "Vytvořit/upravit úložiště",
  "createNewColumn": "Vytvořit nový sloupec",
  "createNewProject": "Vytvořit nový projekt",
  "createSingleAction": "Vytvořit jednotlivou akci",
  "createStage": "Vytvořit fázi",
  "createStandardAction": "Vytvořit standardní akci",
  "currentlyProcessingRepository": "Toto úložiště se právě zpracovává",
  "daily": "Denně",
  "date": "Datum",
  "dateUnavailable": "Datum není k dispozici",
  "day": "den",
  "dayS": "den/dní",
  "days": "den/dní",
  "daysBeforeExpirationWarning": "Dny před vypršením platnosti pro zobrazení upozornění",
  "daysBetweenRecurrences": "Dny mezi opakováními",
  "deadline": "Termín",
  "deadlineColon": "Termín: ",
  "deadlineDate": "Datum termínu",
  "deadlineMustBeLaterThanEarliestStart": "Termín musí být pozdější nebo stejný jako nejdřívější začátek",
  "deadlineTime": "Čas termínu",
  "defaultChatbot": "Výchozí chatbot",
  "delete": "Smazat",
  "deleteAllTypeTestData": "Smazat všechna testovací data {{type}}",
  "deleteAllUnplannedProjects": "Smazat všechny nenaplánované projekty",
  "deleteAllUnplannedSamples": "Smazat všechny nenaplánované vzorky",
  "deleteColumn": "Smazat sloupec",
  "deleteCompetenceGroup": "Smazat skupinu kompetencí",
  "deleteCompetenceGroupWarning": "Smazáním zůstanou úkoly v následujících analýzách bez skupiny kompetencí. Před odebráním zajistěte náhradu.",
  "deleteConstraint": "Smazat omezení",
  "deleteData": "Smazat data",
  "deleteInstrument": "Smazat přístroj",
  "deleteInstrumentWarning": "Bude také smazán pro ostatní týmy na tomto místě.",
  "deleteProjects": "Smazat projekty",
  "deleteSample": "Smazat vzorek",
  "deleteSamples": "Smazat vzorky",
  "deleteThisRow": "Smazat tento řádek",
  "description": "Popis",
  "designTool": "Návrhový nástroj",
  "done": "Hotovo",
  "draft": "návrh",
  "dragAndDropFiles": "Přetáhněte soubory sem nebo je vyberte kliknutím",
  "dragAndDropFolders": "Přetáhněte složky sem nebo vyberte konkrétní soubory kliknutím",
  "dropFilesHere": "Přetáhněte soubory sem",
  "dropFoldersHere": "Sem přetáhněte složky...",
  "duplicate": "Duplikovat",
  "durationHHMM": "Doba trvání (HH:MM)",
  "earliestStart": "Nejdřívější začátek",
  "edit": "Upravit",
  "editAction": "Upravit akci",
  "editAdmin": "Upravit správce",
  "editAnalysisGroup": "Upravit skupinu analýz",
  "editAnalysisTask": "Upravit úkol analýzy",
  "editChatbot": "Upravit chatbota",
  "editCompetenceGroup": "Upravit skupinu kompetencí",
  "editConnectionFromTo": "Upravit propojení od {{from}} k {{to}}",
  "editConversation": "Upravit konverzaci",
  "editGroup": "Upravit skupinu",
  "editInstrument": "Upravit přístroj",
  "editItem": "Upravit {{item}}",
  "editLocationName": "Upravit název místa",
  "editMaintenanceFor": "Upravit {{name}} pro {{assetName}}",
  "editMember": "Upravit člena",
  "editOffsite": "Upravit MIMO PRACOVIŠTĚ",
  "editProject": "Upravit projekt",
  "editProjectGroup": "Upravit skupinu projektů",
  "editProjectTemplate": "Upravit šablonu projektu",
  "editProjectTemplateDraft": "Upravit NÁVRH šablony projektu",
  "editRepository": "Upravit úložiště",
  "editSampleName": "Upravit vzorek: {{name}}",
  "editSheet": "Upravit list {{name}}",
  "editStandardAction": "Upravit standardní akci",
  "editTask": "Upravit úkol",
  "editTeam": "Upravit tým",
  "edited": "Upraveno",
  "email": "e-mail",
  "emailCannotContainDoubleDots": "E-mail nemůže obsahovat '..'",
  "emailLabel": "E-mail",
  "endDate": "Datum ukončení",
  "enterSimulationMode": "Vstoupit do simulačního režimu",
  "errors": "Chyby",
  "errorsProcessingRepository": "Při zpracování tohoto úložiště došlo k chybám",
  "estimatedWorkloadOneWeek": "Odhadovaná pracovní zátěž za týden: ",
  "exclusive": "Exkluzivní",
  "exclusiveSampleIndicator": "* Označuje exkluzivní vzorek",
  "exitSimulation": "UKONČIT SIMULACI",
  "exitSimulationMode": "Ukončit simulační režim",
  "expand": "Rozbalit",
  "exportToExcel": "Exportovat do Excelu",
  "fail": "Nevyhovuje",
  "failSample": "Označit vzorek jako nevyhovující",
  "failSelected": "Označit vybrané jako nevyhovující",
  "failedLoading": "Načítání selhalo: {{members}}",
  "failedToCreateMaintenance": "Nepodařilo se vytvořit údržbu '{{name}}'",
  "failedToDeleteMaintenance": "Nepodařilo se smazat údržbu '{{name}}'",
  "failedToMarkMaintenanceAsCompleted": "Nepodařilo se označit údržbu '{{name}}' jako dokončenou",
  "failedToUpdateMaintenance": "Nepodařilo se aktualizovat údržbu '{{name}}'",
  "failedUploads": "Neúspěšná nahrávání",
  "fileUpload": "Nahrání souboru",
  "fileUploadError": "Při nahrávání souboru došlo k chybě",
  "filenameLabel": "Název souboru: ",
  "filesUploadedSuccessfully": "Soubory byly úspěšně nahrány",
  "fillIn": "Vyplnit",
  "fillInIgnoreOverbooking": "Vyplnit ignorovat přebukování",
  "filter": "Filtrovat",
  "filterByName": "Filtrovat podle názvu",
  "filterBySampleName": "Filtrovat podle názvu vzorku",
  "filterBySampleProductName": "Filtrovat podle názvu vzorku/produktu",
  "filterByText": "Filtrovat podle textu",
  "finished": "Dokončeno",
  "flag": "Označit",
  "flagSample": "Označit vzorek",
  "followingErrorsWhileImporting": "Následující chyby při importu:",
  "free": "Volný",
  "from": "Od",
  "fromDate": "Od data",
  "fromTime": "Od času (HH:MM)",
  "fromTimeHH": "Od času (HH)",
  "fromTimeHHMM": "Od času (HH:MM)",
  "futureAnalysisTaskCantBe": "Budoucí úkol analýzy nemůže být {{state}}",
  "generate": "Generovat",
  "globalChatbot": "Globální chatbot",
  "goBack": "Zpět",
  "goBackToChat": "Zpět na chat",
  "greyTaskTimePercentage": "Podíl času šedých úkolů z celkového času (G2T)",
  "groupMembers": "Členové skupiny",
  "groupName": "Název skupiny",
  "help": "Nápověda",
  "helpBackToApp": "Zpět do aplikace",
  "helpHome": "Hlavní stránka nápovědy",
  "helpPageNotFound": "Stránka nápovědy nenalezena",
  "helpSearch": "Hledat v nápovědě",
  "helpAppTitle": "Nápověda Plannertech",
  "hidden": "Skryto",
  "hideMore": "Skrýt více",
  "highestPriority": "1 je nejvyšší priorita",
  "history": "Historie",
  "home": "Domů",
  "hour": "hodina",
  "iCalendarOutlookIntegration": "Integrace iCalendar / Outlook",
  "iap": "IAP",
  "ignoreAllGreytasks": "Ignorovat všechny šedé úkoly",
  "ignoredByIap": "Ignorováno IAP",
  "includingToday": "Včetně dneška",
  "importedTask": "Importovaný úkol",
  "busyOnAnotherTeam": "Zaneprázdněn v jiném týmu",
  "includeDoneSamples": "Zahrnout dokončené vzorky",
  "includeOverdue": "Zahrnout po termínu",
  "includeToday": "Zahrnout dnešek",
  "iapIncludeTodayWarningIAP": "Upozornění IAP a zahrnout dnešek – úkoly naplánované dříve dnes lze také přesunout, pokud nejsou uzamčeny!",
  "iapIncludeTodayWarningFillIn": "Upozornění vyplnit a zahrnout dnešek – úkolům naplánovaným dříve dnes lze také přidělit nové vzorky!",
  "initials": "Iniciály",
  "inputLastMonth": "Vstup minulý měsíc",
  "inputThisMonth": "Vstup tento měsíc",
  "instrument": "Přístroj",
  "instrumentConstraints": "Omezení přístroje",
  "instrumentLog": "Protokol přístroje",
  "instrumentName": "Název přístroje",
  "instrumentOffset": "Posun přístroje (HH:MM)",
  "instrumentOverbooking": "Přebukování přístroje",
  "instrumentPerSampleDuration": "Doba trvání přístroje na vzorek (HH:MM:SS)",
  "instrumentSetup": "Nastavení přístroje {{name}}",
  "instrumentSetuptime": "Čas nastavení přístroje (HH:MM)",
  "instrumentTime": "Čas přístroje",
  "instrumentView": "Zobrazení přístroje",
  "instruments": "Přístroje",
  "instrumentsWithExpiredMaintenance": "Existují přístroje s prošlou údržbou",
  "instrumentsWithMaintenanceReminders": "Existují přístroje s připomínkami údržby",
  "integration": "Integrace",
  "invalidDate": "Neplatné datum",
  "invalidOutlookLink": "Neplatný odkaz iCalendar / Outlook",
  "isInSimulationMode": "{{initials}} je v simulačním režimu",
  "isSimulating": "{{initials}} simuluje...",
  "keepExistingConnections": "Zachovat stávající propojení",
  "labelAlreadyLoaded": "Již načteno: {{count}}",
  "labelCreated": "Vytvořeno: {{count}}",
  "labelDeleted": "Smazáno: {{count}}",
  "labelDeletedOrFinished": "Smazáno nebo označeno jako dokončené: {{count}}",
  "labelDoneDeleted": "Hotovo/Smazáno: {{count}}",
  "labelUpdatedInformation": "Aktualizované informace: {{count}}",
  "lastErrorLog": "Poslední protokol chyb",
  "lastWeek": "Minulý týden",
  "latestArrival": "Nejpozdější příjezd",
  "leadTimesInWorkDays": "Dodací lhůty v pracovních dnech",
  "leaveEmptyIfNotUsed": "(nechat prázdné, pokud se nepoužívá)",
  "leaveEmptyIfNotUsedDefault": "(nechat prázdné, pokud se nepoužívá, výchozí={{defaultValue}})",
  "loadFromTemplate": "Načíst ze šablony",
  "loading": "NAČÍTÁNÍ",
  "loadingEllipsis": "Načítání...",
  "loadingSamples": "Načítání vzorků",
  "loadingSheet": "Načítání listu",
  "loadingSheets": "Načítání listů",
  "location": "Místo",
  "locationColon": "Místo: {{name}}",
  "locationName": "Název místa",
  "lockItemType": "Zamknout {{itemType}}",
  "lockSamples": "Zamknout vzorky",
  "lockUnlockSamplesLabel": "Zamknout/odemknout vzorky:",
  "locks": "Zámky",
  "locksAllFutureAnalysisTasks": "Zamkne všechny budoucí naplánované úkoly analýzy",
  "locksAllFutureProjectActions": "Zamkne všechny budoucí naplánované akce projektu",
  "login": "Přihlásit se",
  "logout": "Odhlásit se",
  "maintenanceCreatedSuccessfully": "Údržba '{{name}}' byla úspěšně vytvořena",
  "maintenanceDeletedSuccessfully": "Údržba '{{name}}' byla úspěšně smazána",
  "maintenanceExpired": "Platnost údržby vypršela",
  "maintenanceExpiresInDays": "Platnost údržby vyprší za méně než {{days}} dní",
  "maintenanceMarkedAsCompleted": "Údržba '{{name}}' označena jako dokončená",
  "maintenanceName": "Název údržby",
  "maintenanceUpdatedSuccessfully": "Údržba '{{name}}' byla úspěšně aktualizována",
  "mandatoryIfRecurrenceUsed": "(povinné, pokud se používá opakování)",
  "manualSample": "Ruční vzorek",
  "manualSheetConfiguration": "Ruční konfigurace listu",
  "markAsDone": "Označit jako hotové",
  "maxSampleCount": "Maximální počet vzorků",
  "maxSampleCountLabel": "Max. počet vzorků: ",
  "maxTimeBetweenActions": "Maximální čas mezi akcemi (DD:HH:MM)",
  "maxTimeBetweenTasks": "Maximální čas mezi úkoly (DD:HH:MM)",
  "member": "Člen",
  "memberHasEnabledICalendarOutlookIntegration": "Člen povolil integraci iCalendar / Outlook",
  "memberHasEnabledOutlook": "Člen povolil integraci iCalendar / Outlook",
  "memberPermissions": "Oprávnění člena",
  "memberPlan": "Plán člena",
  "memberTime": "Čas člena",
  "membersGoDirectlyToMemberPlan": "Členové přecházejí přímo na plán člena",
  "message": "Zpráva",
  "metric": "Metrika",
  "minSampleCount": "Minimální počet vzorků",
  "minSampleMustBeLowerThanMax": "Minimální počet vzorků musí být nižší než maximální počet",
  "minTimeBetweenActions": "Minimální čas mezi akcemi (DD:HH:MM)",
  "minTimeBetweenTasks": "Minimální čas mezi úkoly (DD:HH:MM)",
  "minTimeMustBeSmallerThanMax": "Minimální čas mezi musí být menší než maximální čas mezi",
  "minimumDuration": "Minimální doba trvání: {{time}}",
  "minute": "minuta",
  "missingPasswordRequirements": "Chybějící požadavky na heslo: {{requirements}}",
  "months": "Měsíce",
  "movedBy": "Přesunuto kým",
  "movedFrom": "Přesunuto odkud",
  "movedTo": "Přesunuto kam",
  "mustBeIcsLink": "Musí být odkaz .ics",
  "name": "Název",
  "namePerformer": "Vykonavatel {{name}}",
  "nameTooLongTitle": "Název je příliš dlouhý (max. 100 znaků)",
  "newAnalysisTaskBundle": "Nový balíček úkolů analýzy",
  "newChat": "Nový chat",
  "newInstrument": "Nový přístroj",
  "newProject": "Nový projekt",
  "newProjectTemplateDraft": "NÁVRH nové šablony projektu",
  "newStart": "Nový začátek",
  "nextDay": "Následující den",
  "nextWeek": "Příští týden",
  "no": "Ne",
  "noAnalysesForProduct": "Pro tento produkt nebyly nalezeny žádné analýzy.",
  "noAssetsFound": "Nebyla nalezena žádná aktiva",
  "noChanges": "Žádné změny",
  "noChatbotSelected": "Žádný chatbot není vybrán",
  "noDataFound": "Nebyla nalezena žádná data",
  "noErrorsToDisplay": "Žádné chyby k zobrazení.",
  "noGroup": "Bez skupiny",
  "noMembersLoaded": "Nebyli načteni žádní členové.",
  "noOfRecurrences": "Počet opakování",
  "noReferencesAvailable": "Žádné dostupné reference.",
  "noSamples": "Žádné vzorky",
  "noSamplesAvailable": "Žádné dostupné vzorky",
  "noSearchResults": "Žádné výsledky hledání",
  "noTimeLimitUnlessSpecified": "Bez časového omezení, pokud není uvedeno",
  "none": "Žádné",
  "default": "Výchozí",
  "notAvailable": "Není k dispozici",
  "notEnoughRoomForDuration": "Nedostatek místa pro dobu trvání",
  "notStarted": "Nezahájeno",
  "numberOfObservations": "Počet pozorování",
  "numberOfRecurrences": "Počet opakování",
  "numericInputBetweenTimeRange": "Zadejte prosím číselnou hodnotu mezi 00:00 a 23:59",
  "offsiteCalendar": "Kalendář MIMO PRACOVIŠTĚ",
  "ok": "OK",
  "oldInstrument": "Starý přístroj",
  "oldStart": "Starý začátek",
  "onlyAdvancedUsersInfo": "Nejdřívější začátek i propojení používají pouze pokročilí uživatelé",
  "onsite": "Na místě",
  "openReferences": "Otevřít reference",
  "operationalGreyTaskTimePercentage": "Podíl času provozních šedých úkolů z celkového času (OG2T)",
  "operationalTask": "Provozní úkol",
  "otherPlannerSimulating": "{{initials}} je v simulačním režimu",
  "outlookLinkLabel": "Odkaz iCalendar / Outlook",
  "outputLastMonth": "Výstup minulý měsíc",
  "outputThisMonth": "Výstup tento měsíc",
  "parentColumn": "Nadřazený sloupec",
  "password": "Heslo",
  "paused": "Pozastaveno",
  "peopleSetup": "Nastavení osob",
  "perSampleDuration": "Doba trvání na vzorek (HH:MM:SS)",
  "perSampleDurationForPeopleSetup": "Doba trvání na vzorek pro nastavení osob",
  "performerConstraintsCount": "Počet omezení vykonavatele",
  "performerConstraintsLabel": "Omezení vykonavatele",
  "permanentApiToken": "Trvalý token API",
  "permanentApiTokenDescription": "Toto je trvalý token API, který vám umožňuje přistupovat k vašemu týmu prostřednictvím našeho API. Zkopírujte jej a uložte na bezpečném místě.",
  "pinConversation": "Připnout konverzaci",
  "planned": "Naplánováno",
  "planner": "Plánovač",
  "plannertechLanguage": "Jazyk Plannertech",
  "plannertechVariable": "Proměnná Plannertech",
  "pleaseChooseColor": "Vyberte prosím barvu pro analýzu",
  "pleaseFillOutAnalysisName": "Vyplňte prosím název analýzy",
  "pleaseFillOutRequiredTaskParams": "Vyplňte prosím požadované parametry úkolu",
  "pleaseGiveEmptyOrFullInput": "Zadejte prosím prázdný nebo úplný vstup",
  "pleaseGiveNumericInput": "Zadejte prosím číselný vstup",
  "pleaseInputValidDate": "Zadejte prosím platné datum",
  "pleaseSelectAtLeastOneItem": "Vyberte prosím alespoň jednu položku",
  "pleaseSelectColor": "Vyberte prosím barvu",
  "pleaseSelectFirstDay": "Vyberte prosím první den.",
  "pleaseSelectLastDay": "Vyberte prosím poslední den.",
  "pleaseSelectTimezone": "Vyberte prosím časové pásmo",
  "previousDay": "Předchozí den",
  "primary": "Primární",
  "primaryInstrument": "Primární přístroj",
  "prioritizeByDeadline": "Upřednostnit IAP podle termínu",
  "prioritizeByPriority": "Upřednostnit IAP podle čísla priority",
  "priority": "Priorita",
  "priorityHigh": "(Vysoká)",
  "priorityLow": "(Nízká)",
  "priorityMedium": "(Střední)",
  "process": "Proces",
  "processed": "Zpracováno",
  "processing": "Zpracovává se...",
  "processingInProgress": "Zpracovává se",
  "productName": "Název produktu",
  "project": "Projekt",
  "projectActions": "akce projektu",
  "projectBatchNumber": "Číslo šarže projektu",
  "projectDeadline": "Termín projektu",
  "projectDescription": "Popis projektu",
  "projectEarliestStart": "Nejdřívější začátek projektu",
  "projectGroup": "Skupina projektů",
  "projectGroupName": "Název skupiny projektů",
  "projectImport": "Import projektu",
  "projectImportVariable": "Proměnná importu projektu",
  "projectMaterialDescription": "Popis materiálu projektu",
  "projectMaterialNumber": "Číslo materiálu projektu",
  "projectName": "Název projektu",
  "projectPriority": "Priorita projektu",
  "projectReleaseDate": "Datum vydání projektu",
  "projectSupplierName": "Název dodavatele projektu",
  "projectSupplierNumber": "Číslo dodavatele projektu",
  "projectTemplate": "šablona projektu",
  "projectTemplates": "Šablony projektů",
  "projectTimePercentage": "Podíl času projektu z celkového času (P2T)",
  "projectView": "Zobrazení projektu",
  "projects": "Projekty",
  "projectsAndActions": "Projekty a akce",
  "promptPrefix": "Prefix promptu",
  "promptTooLongTitle": "Prompt je příliš dlouhý (max. 1200 znaků)",
  "publish": "PUBLIKOVAT",
  "publishSimulationChanges": "Publikovat změny simulačního režimu",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "QC Librarian 3.8",
  "recur": "Opakovat",
  "recurEvery": "Opakovat každých",
  "recurrence": "Opakování",
  "reduce": "Snížit",
  "references": "Reference",
  "rejectedFileTypes": "Odmítnuté typy souborů",
  "rejectedFilesIncompatible": "Následující soubory byly odmítnuty kvůli nekompatibilním formátům",
  "reminderDaysBeforeEndDate": "Připomínka (dny před datem ukončení)",
  "remove": "Odebrat",
  "removeAnalysisFromProduct": "Odebrat {{name}} z tohoto produktu",
  "removeAsset": "Odebrat aktivum",
  "removeEverything": "Odebrat vše",
  "removeInstrument": "Odebrat přístroj",
  "reportGenerator": "Generátor zpráv",
  "reports": "Zprávy",
  "repositories": "Úložiště",
  "repositoryCurrentlyProcessing": "Úložiště momentálně zpracovává soubory. Obnovte stránku pro zobrazení průběhu",
  "repositoryHasUnprocessedFiles": "Toto úložiště obsahuje nezpracované soubory",
  "repositoryIsProcessed": "Toto úložiště bylo zpracováno",
  "repositoryName": "Název úložiště",
  "reset": "Obnovit",
  "role": "Role",
  "row": "Řádek",
  "rowNumber": " řádek {{row}}",
  "runIAP": "Spustit IAP",
  "runningIAP": "Spouštění IAP",
  "sampleAnalysisName": "Název analýzy vzorku",
  "sampleBatchNumber": "Číslo šarže vzorku",
  "sampleHighestPriority": "Vzorek má nejvyšší prioritu",
  "sampleId": "ID vzorku",
  "sampleIdWithValue": "ID vzorku: {{id}}",
  "sampleImport": "Import vzorku",
  "sampleImportVariable": "Proměnná importu vzorku",
  "sampleInProgressOnDoneAnalysis": "Vzorek v průběhu na dokončené analýze",
  "sampleIsDone": "Vzorek je dokončen",
  "sampleLog": "Protokol vzorku",
  "sampleLowestPriority": "Vzorek má nejnižší prioritu",
  "sampleMaterialNumber": "Číslo materiálu vzorku",
  "sampleName": "Název vzorku",
  "sampleObservation": "Pozorování vzorku",
  "sampleObservations": "Pozorování vzorků",
  "samplePercentage": "Procento vzorku",
  "sampleProductDescription": "Popis produktu vzorku",
  "sampleReceivedDate": "Datum přijetí vzorku",
  "sampleStatus": "Stav vzorku",
  "sampleView": "Zobrazení vzorku",
  "samples": "Vzorky",
  "samplesWithName": "Vzorky s názvem {{name}}",
  "samplesWithoutProduct": "Vzorky bez produktu",
  "save": "Uložit",
  "saveAs": "Uložit jako",
  "saveAsDraft": "Uložit jako NÁVRH {{type}}",
  "saveAsNew": "Uložit jako nové",
  "saveAsNewAnalysis": "Uložit jako novou analýzu",
  "saveAsNewTemplate": "Uložit jako novou šablonu",
  "saveAsType": "Uložit jako {{type}}",
  "scrollToTop": "Přejít nahoru",
  "scrumView": "Zobrazení Scrum",
  "scrumViewOrdering": "Řazení zobrazení Scrum",
  "searchBySampleName": "Hledat podle názvu vzorku...",
  "searchCountry": "Hledat zemi",
  "seats": "Místa",
  "second": "sekunda",
  "secondaryInstrumentMustHaveAllowedInstrument": "Nastavení sekundárního přístroje musí mít alespoň jeden povolený přístroj",
  "selectAll": "Vybrat vše",
  "selectChatbot": "Vybrat chatbota",
  "selectDefaultChatbot": "Vybrat výchozího chatbota",
  "selectEntireDay": "Vybrat celý den",
  "selectEntireWorkday": "Vybrat celý pracovní den",
  "selectLocation": "Vybrat místo...",
  "selectSamples": "Vybrat vzorky",
  "selectState": "Vybrat stav...",
  "selectTimezone": "Vybrat časové pásmo...",
  "selectType": "Vybrat typ",
  "selectedFilesReadyForSubmit": "Vybrané soubory/složky připraveny k odeslání:",
  "selectedProduct": "Vybraný produkt",
  "setPlannedValues": "Nastavit plánované hodnoty",
  "settings": "Nastavení",
  "settingsForQcLibrarian": "Nastavení pro QC Librarian",
  "setupTimeForPeopleSetup": "Čas nastavení pro nastavení osob",
  "setuptime": "Čas nastavení (HH:MM)",
  "sheetName": "Název listu",
  "sheetNameLabel": "Název listu",
  "sheetType": "Typ listu",
  "shouldBeEqualTo": "musí být rovno",
  "shouldNotBeEqualTo": "nesmí být rovno",
  "showAnalyses": "Zobrazit analýzy",
  "showErrors": "Zobrazit chyby",
  "showLastErrorLog": "Zobrazit poslední protokol chyb",
  "showLibrarian": "Zobrazit Librarian",
  "showLog": "Zobrazit protokol",
  "showMore": "Zobrazit více",
  "showOnPlan": "Zobrazit v plánu",
  "showProjects": "Zobrazit projekty",
  "shown": "Viditelné",
  "simulationMode": "Simulační režim",
  "simulationModeLogoutWarning": "Aktuálně jste v simulačním režimu. Odhlášením zahodíte změny!",
  "simulationModeOccupied": "SIMULAČNÍ REŽIM OBSAZEN",
  "simulationModeUpper": "SIMULAČNÍ REŽIM",
  "somethingWentWrong": "Něco se pokazilo",
  "sortByProduct": "Seřadit podle produktu",
  "sortByTime": "Seřadit podle času",
  "sortByTimeDescription": "Řadí akce Nevyřízených položek a K vyřízení podle termínů a Naplánované a Dokončené podle času zahájení",
  "speechToTextLanguage": "Jazyk převodu řeči na text",
  "spreadsheetColumnName": "Název sloupce tabulky",
  "stage": "Fáze",
  "standardActions": "Standardní akce",
  "start": "Zahájit",
  "startDate": "Datum zahájení",
  "startDateCheckboxInfo": "Pokud je zaškrtnuto, termín projektu, termín akce a začátek akce se posunou relativně k začátku projektu",
  "startEndDate": "Datum zahájení/ukončení",
  "startProcessingInfo": "Tím se spustí zpracování úložiště. Může to chvíli trvat v závislosti na velikosti úložiště",
  "startRecurrence": "Zahájit opakování",
  "startTime": "Čas zahájení",
  "started": "Zahájeno",
  "state": "Stav",
  "status": "Stav",
  "submit": "Odeslat",
  "successfullyLoaded": "Úspěšně načteno: {{members}}",
  "successfullyUploadedFiles": "Soubory byly úspěšně nahrány",
  "systemPrompt": "Systémový prompt",
  "taskBelongsToTeam": "Úkol patří týmu: {{team}}",
  "taskCount": "Počet úkolů",
  "taskDesignTool": "Návrhový nástroj úkolů",
  "taskLog": "Protokol úkolů",
  "taskName": "Název úkolu",
  "taskPerformerConstraints": "Omezení vykonavatele úkolu",
  "tasks": "Úkoly",
  "team": "Tým",
  "teamChatbot": "Chatbot týmu",
  "teamLabel": "Tým: {{name}}",
  "teamMember": "Člen týmu",
  "teamName": "Název týmu",
  "teamPlan": "Plán týmu",
  "teamUsageTitle": "Využití {{name}}",
  "teams": "Týmy",
  "templateIsDraft": "Tato šablona projektu je návrh",
  "templateName": "Název šablony",
  "theProjectIsDone": "Projekt je dokončen",
  "timeConstraints": "Časová omezení",
  "timeHHMM": "Čas (HH:MM)",
  "timePeriod": "Časové období",
  "timestamp": "Časové razítko",
  "timezone": "Časové pásmo",
  "to": "Do",
  "toConfirmDeletionType": "Pro potvrzení smazání napište {{keyword}}",
  "toConfirmDeletionTypeDeleteData": "Pro potvrzení smazání napište {{keyword}} a stiskněte potvrdit. Tím trvale smažete testovací data, i v simulačním režimu. Vrácení zpět není možné.",
  "toConfirmDeletionTypeKeyword": "Pro potvrzení smazání napište {{keyword}} a stiskněte potvrdit",
  "toDate": "Do data",
  "toDo": "K vyřízení",
  "toTime": "Do času (HH:MM)",
  "toTimeHH": "Do času (HH)",
  "toTimeHHMM": "Do času (HH:MM)",
  "today": "Dnes",
  "tokens": "Tokeny",
  "total": "Celkem",
  "normalSeats": "Normální",
  "tryReloadingOrContactSupport": "Zkuste obnovit stránku nebo kontaktujte podporu, pokud problém přetrvává!",
  "type": "Typ",
  "typeBeforeConfirming": "napište {{keyword}} před potvrzením",
  "typeOrSelect": "Napište nebo vyberte...",
  "typeYourMessage": "Napište svou zprávu...",
  "unassignedSamples": "Nepřiřazené vzorky",
  "unassignedSamplesFor": "Nepřiřazené vzorky pro '{{name}}'",
  "unflag": "Odznačit",
  "unflagSample": "Odznačit vzorek",
  "unlockItemType": "Odemknout {{itemType}}",
  "unlockSamples": "Odemknout vzorky",
  "unlocks": "Odemknutí",
  "unlocksAllFutureAnalysisTasks": "Odemkne všechny budoucí naplánované úkoly analýzy",
  "unlocksAllFutureProjectActions": "Odemkne všechny budoucí naplánované akce projektu",
  "unnamed": "bez názvu",
  "unpinConversation": "Odepnout konverzaci",
  "unplan": "Odplánovat",
  "unplanAnalysis": "Odplánovat analýzu",
  "unplanItemType": "Odplánovat {{itemType}}",
  "unplanSample": "Odplánovat vzorek",
  "unplanSelected": "Odplánovat vybrané",
  "unplanned": "Nenaplánováno",
  "unplannedProjects": "Nenaplánované projekty",
  "unsavedChangesIn": "Existují neuložené změny v:",
  "updateIntegration": "Aktualizovat integraci",
  "updatedIcalOutlook": "iCalendar / Outlook byl aktualizován!",
  "uploadAborted": "Nahrávání bylo přerušeno!",
  "uploadComplete": "Nahrávání dokončeno!",
  "uploadFailedForFile": "Nahrávání selhalo pro soubor: {{path}}",
  "uploadFinished": "Nahrávání dokončeno!",
  "uploadTo": "Nahrát do {{name}}",
  "usage": "Využití",
  "used": "Použito",
  "usedAssets": "Použitá aktiva",
  "usedInstrument": "Použitý přístroj",
  "usedInstruments": "Použité přístroje",
  "username": "Uživatelské jméno",
  "value": "Hodnota",
  "view": "Zobrazit",
  "viewAllAnalysesForProduct": "Zobrazit všechny analýzy pro tento produkt",
  "viewAnalysisSamples": "Zobrazit vzorky analýzy",
  "viewCompact": "Kompaktní zobrazení",
  "viewNormal": "Normální zobrazení",
  "weekNumber": "Týden {{week}}",
  "weekView": "Týdenní zobrazení",
  "dayView": "Denní zobrazení",
  "weekendView": "Zobrazení víkendu",
  "screen": "Obrazovka",
  "clickToSortBy": "Kliknutím seřadit podle {{column}}",
  "fileChangedPleaseReselect": "{{file}} byl změněn. Vyberte soubor znovu",
  "contentTooWideZoomOut": "Obsah je příliš široký pro obrazovku. Pro lepší zážitek oddálte zobrazení ({{key}} +/-)",
  "week": "Týden",
  "weekly": "Týdně",
  "weeks": "týden/týdnů",
  "withConnections": "s propojením",
  "workHours": "Pracovní hodiny",
  "workWeek": "Pracovní týden",
  "years": "Roky",
  "yes": "Ano",
  "youAreInSimulationMode": "Jste v simulačním režimu",
  "zeroHours": "0 hodin",
  "addCustomer": "Přidat zákazníka",
  "addGlobalChatbot": "Přidat globálního chatbota",
  "addGlobalRepository": "Přidat globální úložiště",
  "apiKey": "Klíč API",
  "authenticationCode": "Ověřovací kód",
  "authenticationCodeSentInfo": "Na váš e-mail jsme zaslali ověřovací kód. Zadejte jej výše před přihlášením",
  "chatbotPrefix": "Prefix chatbota",
  "chatbotSystemPrompt": "Systémový prompt chatbota",
  "chatbotSystemPrompts": "Systémové prompty chatbota",
  "citationGuidelines": "Pokyny pro citace",
  "configureMember": "Konfigurovat člena",
  "createApiKey": "Vytvořit klíč API",
  "creatingProject": "Vytváření projektu",
  "currentQuestion": "Aktuální otázka",
  "customerAdminApiKeyForGlobalRepositories": "Klíč API správce zákazníka pro globální úložiště",
  "dateFormatYyyyMmDd": "RRRR-MM-DD",
  "deleteApiKey": "Smazat klíč API",
  "descriptionPrompt": "Prompt popisu",
  "editGlobalMessage": "Upravit globální zprávu",
  "editingProject": "Úprava projektu",
  "editSystemPrompts": "Upravit systémové prompty",
  "filePathPrompt": "Prompt cesty k souboru",
  "fillingInSamples": "Vyplňování vzorků",
  "generalPrefix": "Obecný prefix",
  "globalChatbots": "Globální chatboti",
  "globalRepositories": "Globální úložiště",
  "hideNextWeek": "Skrýt příští týden",
  "hideSatSun": "- So/Ne",
  "manageAdmins": "Spravovat správce",
  "oneWeek": "1 týden",
  "openMetricsPanel": "Otevřít panel metrik/IAP",
  "openTodoList": "Otevřít seznam úkolů",
  "optimizedQuestionPrompt": "Optimalizovaný prompt otázky",
  "plannertech": "Plannertech",
  "plannertechSuite": "Plannertech Suite",
  "plannertechTeamPlan": "Plán týmu Plannertech",
  "previousConversation": "Předchozí konverzace",
  "librarianLogoAlt": "Logo Librarian",
  "qcLibrarianForCompany": "{{company}} QC Librarian",
  "relevantDocumentation": "Relevantní dokumentace",
  "repositoryHasUnprocessedFilesInfo": "V tomto úložišti jsou nezpracované soubory",
  "repositoryIsEmpty": "Toto úložiště je prázdné",
  "repositoryPrefix": "Prefix úložiště",
  "repositoryProcessingInProgressInfo": "Úložiště momentálně zpracovává soubory. Obnovte stránku pro zobrazení průběhu",
  "sampleAllocation": "Přidělování vzorků",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "Místa: {{count}}",
  "excludingToday": "Bez dneška",
  "unplanning": "Odplánování",
  "activeSeats": "Aktivní místa: {{count}}",
  "totalSeats": "Normální místa: {{count}}",
  "purchasedSeats": "Zakoupená místa: {{count}}",
  "globalMessage": "Globální zpráva",
  "clearGlobalMessageConfirm": "Opravdu chcete vymazat globální zprávu? Tím zmizí pro všechny uživatele.",
  "samplesCount": "Vzorky: {{count}}",
  "locations": "Místa",
  "customers": "Zákazníci",
  "editCustomer": "Upravit zákazníka",
  "addCustomerTitle": "Přidat zákazníka",
  "deleteCustomer": "Smazat zákazníka",
  "customerName": "Název zákazníka",
  "customerStatus": "Stav zákazníka",
  "active": "Aktivní",
  "passive": "Pasivní",
  "allowedDomains": "Povolené domény",
  "allowedPerformers": "Povolení vykonavatelé",
  "seatsPurchased": "Zakoupená místa",
  "customerApiKey": "Klíč API zákazníka",
  "durationFormatDDHH": "DD:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "DD:HH:MM",
  "continue": "Pokračovat",
  "showNextWeek": "Zobrazit příští týden",
  "showSatSun": "+ So/Ne",
  "topDescriptionPrompt": "Prompt hlavního popisu",
  "twoWeeks": "2 týdny",
  "updateHelpPage": "Aktualizovat stránku nápovědy",
  "userAlreadyLoggedInTakeOver": "Uživatel je již přihlášen. Pro převzetí relace stiskněte potvrdit",
  "zoomIn": "Přiblížit",
  "zoomOut": "Oddálit",
  "constraintWarningTitle": "Došlo k {{count}} upozornění(m)",
  "assetStatusFree": "Volný",
  "assetStatusBooked": "Zarezervováno",
  "dateTo": "do",
  "futureAnalysisTaskCantBeFinished": "Budoucí úkol analýzy nelze dokončit",
  "tableNotFound": "Tabulka nebyla nalezena",
  "conversionSheetFilename": "Převodní list.xlsx",
  "selectTeam": "Select a team to log in to",
  "admin": "Admin",
  "customerAdmin": "Zákaznický admin",
  "attachFile": "Připojit soubor",
  "removeFile": "Odebrat soubor",
  "fileTooLarge": "Soubor je příliš velký (max 10 MB)",
  "tooManyFiles": "Maximálně 3 soubory na zprávu",
  "unsupportedFileType": "Nepodporovaný typ souboru. Povolené: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
